import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import { Calendar, Loader, LoaderCircle } from "lucide-react";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useAppSelector } from "store/store";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { Service } from "utils/services";
import { Button } from "react-day-picker";
import TimePicker from "components/app/function/TimePicker";
import ClockTimesheetPopover from "./ClockTimesheetPopover";

const TimesheetCard = ({
  shopEmployeeTimesheets,
  fetchMoreShopEmployeeTimesheetSearch,
  shopEmployeeLoading,
  listRef,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  setOpenDrawer,
  setItemDetail,
  getShopEmployeeTimesheetDetail,
  dob,
  handleClickUrl,
  openPopoverInTime,
  setOpenPopoverInTime,
  attendanceSetting,
  timeInValues,
  handleChangeTimeIn,
  submitUpdateClockTime,
  loadingsubmitUpdateClockTime,
  openPopoverOutTime,
  setOpenPopoverOutTime,
  timeOutValues,
  handleChangeTimeOut,
  children,
}: any) => {
  const { indexTimeSheet } = useAppSelector((state) => state.header);
  return (
    <>
      {children}
      <InfiniteScroll
        dataLength={shopEmployeeTimesheets?.data?.length || 0}
        next={() =>
          fetchMoreShopEmployeeTimesheetSearch({
            next: shopEmployeeLoading.nextPageUrl,
          })
        }
        hasMore={!!shopEmployeeLoading?.nextPageUrl}
        loader={
          <div className="absolute bottom-2 left-0 w-full flex justify-center">
            <LoaderCircle size={30} className="animate-spin text-yellow-400" />
          </div>
        }
      >
        <>
          <div ref={listRef} className={`grid  md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10   `}>
            {shopEmployeeTimesheets?.data?.map((item: any, index: number) => {
              return (
                <div
                  onClick={() => {
                    if (selectProducts) {
                      setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                      return;
                    } else {
                    }
                  }}
                  key={index}
                  className={`group   relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
                >
                  <div className=" w-full relative overflow-hidden aspect-square  ">
                    <ImageUrl className="rounded-t-md w-full h-full  object-cover " src={!item.picture ? noneProfile : item.picture} alt="" />
                    <div
                      className={` ${selectedProductIds.includes(item.id) ? "bg-white" : ""} w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${
                        !selectProducts ? " hidden" : " block"
                      }`}
                    >
                      {selectedProductIds.includes(item.id) ? (
                        <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                      ) : (
                        <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                      )}
                    </div>
                    <HoverCardDetail
                      title="Monthly Attendance Detail Report"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Includes clock-in/out times, breaks, and total hours.</li>
                            <li>Useful for payroll, attendance verification, and compliance.</li>
                            <li>Customize date ranges and filters before printing.</li>
                            <li>Export options may be available (PDF, Excel, etc.).</li>
                          </ul>
                        </>
                      }
                    >
                      <div
                        onClick={() => {
                          setOpenDrawer(1);
                          setItemDetail({ ...item, dob });
                          getShopEmployeeTimesheetDetail(item.employee_id);
                          handleClickUrl(item?.employee_id, "employee_id", dob);
                        }}
                        className={`${
                          selectProducts ? " hidden" : " block"
                        } cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                      >
                        <Calendar className="" />
                      </div>
                    </HoverCardDetail>
                  </div>
                  <div className={`p-4 ${indexTimeSheet === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                    <h4 className="text-md font-semibold line-clamp-2 overflow-hidden h-[25px] text-[15px] ">{item?.local_name}</h4>
                    <span className="text-sm line-clamp-1 overflow-hidden h-[20px]">{item?.department}</span>

                    <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                    <div key={index} className="flex items-center justify-between">
                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Time In"
                        fieldKey="in_time"
                        openPopoverIndex={openPopoverInTime}
                        setOpenPopoverIndex={setOpenPopoverInTime}
                        timeValue={timeInValues[index]}
                        onChangeTime={handleChangeTimeIn}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />

                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Time Out"
                        fieldKey="out_time"
                        openPopoverIndex={openPopoverOutTime}
                        setOpenPopoverIndex={setOpenPopoverOutTime}
                        timeValue={timeOutValues[index]}
                        onChangeTime={handleChangeTimeOut}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            {!shopEmployeeTimesheets?.next_page_url ? (
              <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                <b>Nothing more to load!</b>
              </p>
            ) : (
              ""
            )}
          </div>
        </>
      </InfiniteScroll>
    </>
  );
};

export default TimesheetCard;
